import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromAppointmentDataStore from './state/appointment-data-store.reducer';

/* effects */
import { AppointmentDataStoreEffects } from './state/appointment-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* AppointmentDataStore State */
    StoreModule.forFeature(
      fromAppointmentDataStore.featureKey,
      fromAppointmentDataStore.reducer,
      { initialState: fromAppointmentDataStore.initialState },
    ),
    EffectsModule.forFeature([AppointmentDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class AppointmentDataStoreModule {}
